export default {"src":"/_next/static/media/astronaut-bunny.a01e5d73.gif","height":625,"width":625};